import { Component } from 'react';

import StateManagedPage from "../../components/pages/state-managed-pages";

import AccessPage from '../../components/pages/access-page';
import AccessCompany from '../../components/pages/access-company';

import GrantsApi from '../../lib/grants/grants-api';
import {stringToFriendlyDatetime} from "../../lib/helpers/datetime-helpers";

export default class AccessMain extends Component {
    constructor(props) {
        super(props);

        this.state = {
            grant: {},
            pages: [

            ]
        }
    }

    componentDidMount() {
        // We do some API stuff later
        const api = new GrantsApi();

        api.getGrant(this.props.grantId).then(({ data }) => {

            this.setState({ grant: data }, () => this.generatePages());
        });

    }


    generatePages() {
        const { grant } = this.state;

        let configs = (grant.hasOwnProperty('eligibility_config') && Array.isArray(grant.eligibility_config) ) ?  [ ...grant.eligibility_config ] : [];

        configs = configs.map(con => {
            const questions = con.questions.map(({ label, required }) => ({
                type: 'checkbox',
                label,
                value: label,
                required: required,
                questionTitle: con.title,
            }))

            const files = con.files.map(({ id, name, path }) => ({
                type: 'file',
                id,
                name,
                path
            }));

            return {
                include_eligibility: true,
                title: con.title,
                description: con.description,
                items: [ ...questions, ...files ]
            }
        });

        let applicationWindow = '';

        if(!grant.available_from && !grant.available_to) {
            applicationWindow = 'This is no deadline for this grant';
        }

        if(grant.available_from) {
            applicationWindow = 'Available from: ' + stringToFriendlyDatetime(grant.available_from);
        }

        if(grant.available_to) {
            applicationWindow  += ' Available to: ' + stringToFriendlyDatetime(grant.available_to)
        }


        this.setState({
            pages : [
                {
                    title: 'Overview',
                    subtitle: `${grant.name}`,
                    data: [
                        {
                            title: 'Grant Available',
                            items: [
                                {
                                    type: 'text',
                                    value: grant.meta?.grant_value_description
                                },
                            ]
                        },
                        {
                            title: 'Application Window',
                            items: [
                                {
                                    type: 'text',
                                    value: applicationWindow
                                },
                            ]
                        },
                        {
                            title: 'Description',
                            items: [
                                {
                                    type: 'text',
                                    value: grant.description
                                },
                            ]
                        }
                    ],
                    Component: AccessPage,
                },
                {
                    title: 'Company Information',
                    subtitle: `${grant.name}`,
                    data: [],
                    Component: AccessCompany,
                },
                {
                    title: 'Eligibility',
                    subtitle: `${grant.name}`,
                    grant: grant,
                    data: [
                        {
                            title:  'Guidance notes',
                            items: [
                                {
                                    include_eligibility: false,
                                    type: 'text',
                                    value: grant.meta?.eligibility_notes
                                },
                                {
                                    include_eligibility: false,
                                    type: 'text',
                                    value: grant.meta?.mandatory_requirement_notes
                                },
                            ]
                        },
                        ...configs
                    ],
                    Component: AccessPage,
                }
            ]
        });
    }

    render() {
        return (
            <>
                {
                    this.state.pages.length >= 1 &&
                    <StateManagedPage pages={this.state.pages} grantId={this.props.grantId} grant={this.state.grant}/>

                }
            </>
        )
    }
}
